export class DateHelper {
    static setEndOfDayToDate(date: Date | null): Date | null {
        if (!date) {
            return null;
        }

        date.setHours(23);
        date.setMinutes(59);
        date.setSeconds(59);

        return date;
    }

    static millisToMinutesAndSeconds(millis: number): string {
        const minutes = Math.floor(millis / 60000);
        const seconds = ((millis % 60000) / 1000).toFixed(0);
        return minutes + ':' + (Number(seconds) < 10 ? '0' : '') + seconds;
    }
}
